// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const GenderWrapper: StatelessFunctionalComponent<*> = styled.div`

  @media screen and (max-width: 580px) {
    .Gender {
      flex-direction: column;
    }
  }

  .Gender {
    max-width: 650px;
    margin: auto;
    background-color: #fff;
    padding: 12px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-title {
      font-size: 1.6em;
      font-weight: 400;
      color: #525252;
      padding-left: 20px;
    }
    
    &-error {
      color: var(--input-error-color);
    }

    @media screen and (max-width: 650px) {
      &-title {
        margin-bottom: 10px;
        margin-top: 10px;
        padding-left: 0;
      }
    }
    
    &-buttons {
      display: flex;
      justify-content: space-between;
    }

    &-buttons > * {
      margin: 0 10px;
    }
    
    &-button {
      height: auto !important;
      min-width: 150px;
      padding: 16px;
      line-height: 1 !important;
      font-size: 18px;
      border-radius: 10px;
      cursor: pointer;
      color: var(--white-color);
    }
    
    &-button:focus {
      outline: 2px solid lightskyblue;
    }

    &-button--off {
      background-color: var(--text-color-1) !important;
    }

    &-button--on {
      background-color: var(--blue-color);
    }
  }
`;

export default GenderWrapper;
